import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { Loadin } from '../../../shared';
import { useEffect, useState } from 'react';
import { RPSB, ReportsServicesRpsb } from '../../../../services/api/reports/ReportsServicesRpsb';
import { formatDateWhitoutHour } from '../../../../services/helpers/helpers';

interface ICardRpsb  {
    data: RPSB
}

export const CardRPSB = ({data}: ICardRpsb) => {

    const uuid = data.uuid;
    const [risr, setRisr] = useState<RPSB>();

    useEffect(() => {
        fetchData();        
    }, [uuid]);

    const fetchData = () => {
        if(uuid){
            ReportsServicesRpsb.get(uuid)
            .then((result) => {
                if(result instanceof Error){
                    console.log(result.message);
                }else{
                    setRisr(result);
                }
            });
        }
    }; 

    if(risr == undefined){
        return(
            <Box>
                <Loadin/>
            </Box>
        );
    }
        
    
    return(
        <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'} padding={1}>

            <Accordion variant='outlined' square={true} sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    <Typography variant='subtitle1'>Geral</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid>
                        <Grid container alignContent={'center'} spacing={2} gap={2}>
                            <Grid container gap={2} padding={1}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={formatDateWhitoutHour(risr.periodo_referencia)}
                                            label='Período de referencia'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.empresa_executora}
                                            label='Empresa executora'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={formatDateWhitoutHour(risr.data_inspecao)}
                                            label='Data de inspeção'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={formatDateWhitoutHour(risr.data_dce)}
                                            label='Data de DCE'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.status_dce}
                                            label='Status da DCE'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.responsavel}
                                            label='Responsável técnico'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.status_dce}
                                            label='Status da DCE'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.art}
                                            label='ART (número)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.orgao}
                                            label='Órgão fiscalizador'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.dpa}
                                            label='Dano Potencial Associado (DPA)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.cri}
                                            label='Categoria de Risco (CRI)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            value={risr.classificacao}
                                            label='Classificação (conforme órgão fiscalizador)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {risr.analiseEstabilidade !== undefined ? (
                <Accordion variant='outlined' square={true} sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <Typography variant='subtitle1'>Ánalises de Estabilidade</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container alignContent={'center'} spacing={2} gap={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={risr.analiseEstabilidade.metodo_analise}
                                    label='Métodos de análise'
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={risr.analiseEstabilidade.modos_falha}
                                    label='Modos de falha'
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Divider />
                            {risr.analiseEstabilidade.informacoes && risr.analiseEstabilidade.informacoes.length > 0 ? (
                                risr.analiseEstabilidade.informacoes.map((info, index) => (
                                    <Grid container spacing={2} key={index} padding={1}>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.condicao}
                                                label='Condição'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.fator_seguranca}
                                                label='Fator de segurança'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.secao}
                                                label='Seção'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.valor_referencia}
                                                label='Valor de referência'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))
                            ) : null }
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {risr.verificacaoHidrologica !== undefined ? (
                <Accordion variant='outlined' square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <Typography variant='subtitle1'>Verificação Hidrológica/Hidráulica</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                                <Grid container alignContent={'center'} spacing={2} gap={2}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.area_drenagem}
                                                    label='Área de drenagem'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.bombeamento}
                                                    label='Bombeamento'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.borda_livre}
                                                    label='Borda livre'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.duracao_chuva}
                                                    label='Duração da chuva'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.na_maximo_maximorum}
                                                    label='NA maximo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.na_maximo_operacional}
                                                    label='NA maximo operacional'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.precipitacao_pmp}
                                                    label='Precipitação PMP'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.precipitacao_projeto}
                                                    label='Precipitação do projeto'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={risr.verificacaoHidrologica.vazao_maxima}
                                                    label='Vazão maxima'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                               <Divider/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}
            
            {risr.recomendacoes.length > 0 ? (
                <Accordion variant='outlined' square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <Typography variant='subtitle1'>Recomendações</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {risr.recomendacoes.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.recomendacao}
                                                    label='Recomendação'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={formatDateWhitoutHour(item.prazo)}
                                                    label='Prazo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                               <Divider/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}
            

        </Box>
    );

};